module.exports = __webpack_public_path__ + "img/dashboard.089aab67.png";